<span *ngFor="let image of albums; index as i">
  <img
    [src]="getFullUrl(image.src)"
    alt="lot_image_{{ i + 1 }}"
    [height]="height"
    (click)="open(i)"
  />
</span>
